import { FormattedMessage } from "react-intl";

export function ProgressBar({
  label,
  done,
  total,
  valueAlreadyVisible = false,
  className = "",
}: {
  label: string;
  done?: number | null;
  total?: number | null;
  // Opt in only when the same done/total count is visibly printed beside the bar.
  valueAlreadyVisible?: boolean;
  className?: string;
}) {
  const determinate = total != null && total > 0 && done != null;
  if (!determinate) {
    return (
      <div
        role="progressbar"
        aria-label={label}
        aria-busy="true"
        className={`smycles-skeleton h-1.5 w-full rounded-full ${className}`}
      />
    );
  }
  const value = Math.min(Math.max(done, 0), total);
  return (
    <div className={className}>
      {!valueAlreadyVisible ? (
        <div className="mb-1 text-smycles-label tabular-nums text-ink">
          <FormattedMessage id="common.progressCount" defaultMessage="{done, number} / {total, number}" values={{ done: value, total }} />
        </div>
      ) : null}
      <div
        role="progressbar"
        aria-label={label}
        aria-valuemin={0}
        aria-valuemax={total}
        aria-valuenow={value}
        className="h-1.5 w-full overflow-hidden rounded-full bg-ink/10"
      >
        <div
          className="h-full rounded-full bg-accent transition-[width] duration-[var(--duration-slow)] ease-out motion-reduce:transition-none"
          style={{ width: `${(value / total) * 100}%` }}
        />
      </div>
    </div>
  );
}
